import { EMR_APIS } from "@/api_framework/api_config";

import { IEMRUpdatePayloadProps } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import { VMSEMRUpdateURLContext } from "@/app/context/VMSEMRUpdateURLContext";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useContext } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
type IEMRUpdateProps = { status: boolean; message: any };

AxiosCurlirize(axios, () => {});

export const useUpdateTempEMRAPI = () => {
  const { mappedClinicId } = useAppSelector((state) => state.root.UIStates);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const updateURLOverride = useContext(VMSEMRUpdateURLContext);

  const execute = useCallback(
    async (emrId: string, updateFormFields: IEMRUpdatePayloadProps) => {
      dispatch(
        setLoading({
          key: "isEMRUpdateInProgress",
          status: true,
        }),
      );
      let emrpayload = null;
      emrpayload = {
        ...updateFormFields,
        emr_id: emrId,
        clinic_id: mappedClinicId,
      };

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: IEMRUpdateProps = await axios
          .put(updateURLOverride ?? `${EMR_APIS?.UPDATE_EMR_V2?.baseURL}`, emrpayload, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            dispatch(
              setLoading({
                key: "isEMRUpdateInProgress",
                status: false,
              }),
            );
            if (res.data.status) {
              return { status: true, message: res.data.data };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isEMRUpdateInProgress",
                status: false,
              }),
            );
            if (e.response?.status === 500) {
              toast.error("500 Server Error, Contact Tech Team.");
            }
            captureError(e);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        if (e.response?.status === 500) {
          // toast.error("500 Server Error, Contact Tech Team.");
        }
        dispatch(
          setLoading({
            key: "isEMRUpdateInProgress",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch, updateURLOverride],
  );
  return { execute };
};
